import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

const PRIVATE_SERVERS = 'servers.favorites';

const uid = () => Math.random().toString(16).substring(2);
const guid = () => uid() + uid();

@Injectable()
export class PrivateServersService {
    _dataSbj: BehaviorSubject<IServer[]> = new BehaviorSubject([]);
    data$: Observable<IServer[]> = this._dataSbj.asObservable();

    constructor(
    ) {
        this.getServers().then((servers) => {
            this._dataSbj.next(servers);
        });
    }

    async getServers(): Promise<IServer[]> {
        return new Promise((resolve) => {
            let servers;

            try {
                try {
                    servers = JSON.parse(localStorage.getItem(PRIVATE_SERVERS));
                } catch (err) {
                    // Noop.
                }

                if (!Array.isArray(servers)) {
                    throw new Error('');
                }

                servers = servers.map((server) => ({
                    ...server,

                    _id: server._id || guid(),

                    apiUrl: `${ getUrl(server) }/api/`,
                    websocketUrl: `${ getUrl(server) }/socket/`,
                    prefix: 'local',
                }));
            } catch (err) {
                servers = [];
            }

            resolve(servers);
        });
    }

    add(server: IServer) {
        let servers = this._dataSbj.getValue();
        servers = [...servers, server];
        this._dataSbj.next(servers);

        this._save(servers);
    }

    remove(idx: number) {
        let servers = this._dataSbj.getValue();
        servers.splice(idx, 1)
        servers = [...servers];
        this._dataSbj.next(servers);

        this._save(servers);
    }

    patch(server: IServer, data: any) {
        const servers = this._dataSbj.getValue();
        const idx = servers.findIndex(({ _id }) => _id === server._id);
        const _servers = [...servers];
        _servers.splice(idx, 1, {
            ...server,
            ...data
        });

        this._dataSbj.next(_servers);
    }

    _save(servers: IServer[]) {
        try {
            localStorage.setItem(PRIVATE_SERVERS, JSON.stringify(servers));
        } catch (err) {
            // Noop.
        }
    }
}

function getUrl(server: IServer) {
    const { host, port } = server.settings;

    return `http://${ host }${ port ? (':' + port) : '' }`;
}
